import { useUnderlyingContext } from 'hooks/useUnderlyingContext';

import { HeaderCell } from '../../HeaderCell';
export function RemoveAll() {
  const { hasRemoveAll, onRemoveAll, canBeRemoved, isLoading } = useUnderlyingContext();

  return (
    canBeRemoved && (
      <HeaderCell>
        {hasRemoveAll && (
          <button
            className="btn btn-icon"
            type="button"
            disabled={isLoading}
            onClick={onRemoveAll}
            data-e2e="clear-all-underlyings"
          >
            <i className="clickable icon text-secondary">delete_sweep</i>
          </button>
        )}
      </HeaderCell>
    )
  );
}
